/* eslint-disable max-classes-per-file */
/* eslint-disable no-this-before-super */
/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import "phaser";
import { loadAudio, loadImage, loadSpritesheet } from "./../modules/utiltes"
import { SoundManager } from "./../ScenesHelpers/SoundManager";
import { Entity } from './Entity';
export class SelfDestruction extends Entity {
    /** 
     * SelfDestruction constructor @param {object} scene -scene that SelfDestruction object belongs to- @param {number} x - value of SelfDestruction on x axis - @param {number} y - value of SelfDestruction on y axis - @param {String} key -contains key of SelfDestruction- @param {String} audio -contains audio of SelfDestruction- @param {number} speedx - assign speed of SelfDestruction x axis - @param {number} speedy - assign speed of SelfDestruction x axis - @param {String} type -contains type of entity- @param {String}animeKey -contains unique string for active animation-
     * loadAssets function : load asset on screen and it takes @param {object} scene -scene that selfDestruction object belongs to-  @param {String} key -key of SelfDestruction asset-  @param {String} keyLink -path of asset location- @param {String} audioKey -key of selfDestruction asset-  @param {String} audioLink -path of asset location-
     * */
    setIntervalValue = 16
    constructor(
        scene,
        x,
        y,
        key,
        type,
        scalex,
        scaley,
        animeKey,
        speedx,
        speedy,
        audio,
        player,
        mode
    ) {
        super(scene, x, y, key, type);
        this.key = key;
        this.body.velocity.x = speedx;
        this.body.velocity.y = speedy;
        this.scaleX = scalex;
        this.scaleY = scaley;
        this.audio = audio;
        this.player = player;
        this.mode = mode;

        const setIntervalValue = 16
        const setTimeOut = 1900
        if (animeKey != null) {
            setTimeout(() => {
                super.setTexture(animeKey);
                super.play(animeKey);
            }, setTimeOut);
        }
        setInterval(() => {

            if (this.body != null) {
                this.scaleX = 2 * this.scaleX
                this.scaleY = 2 * this.scaleY
            }


        }, setIntervalValue);
        const OPTIONS = {
            BOSS: {
                "COUNTER": "bosscounter"
            },
            ENEMY: {
                "LEVEL": "enemylevel",
                "KEY": "enemykey"
            },
        }
        for (let i = 0; i < this.scene.enemies.getChildren().length; i++) {
            const enemy = this.scene.enemies.getChildren()[i];
            if (enemy.getData(OPTIONS.ENEMY.KEY) == "boss") {
                enemy.setData(OPTIONS.BOSS.COUNTER, enemy.getData(OPTIONS.BOSS.COUNTER) + 5)
                if (enemy.getData(OPTIONS.BOSS.COUNTER) >= 10 * enemy.getData(OPTIONS.ENEMY.LEVEL)) {
                    enemy.explode();
                }
            } else {
                enemy.explode();
            }
            player.setCurrentPlayerScore(player.getCurrentPlayerScore() + 1);
            if (player.getCurrentPlayerScore() > parseInt(player.getPlayerHighScore(), 10)) {
                player.setPlayerHighScore(player.getCurrentPlayerScore());
            }
        }
        this.player.onDestroy(this.mode);
        this.player.explode();

    }
    static loadAssets(scene, key, keyLink, audio, audioLink) {
        loadImage(scene, key, keyLink)
        loadAudio(scene, `${audio}`, audioLink)
    }
}
export class Bar extends Entity {
    /** 
     * Bar constructor @param {object} scene -scene that Bar object belongs to- @param {number} x - value of Bar on x axis - @param {number} y - value of Bar on y axis - @param {String} key -contains key of Bar- @param {String}animeKey -contains unique string for active animation-
     * loadAssets function : load asset on screen and it takes @param {object} scene -scene that Bar object belongs to-  @param {String} key -key of SelfDestruction asset-  @param {String} keyLink -path of asset location- @param {number} framex -number of frames x axis-  @param {number} framey -number of frames y axis-
     * */
    constructor(scene, x, y, key, type, animekey) {
        super(scene, x, y, key, type);
        this.key = key;
        this.setDepth(5);
        this.alpha = 0.3;
        if (animekey != null) {
            super.setTexture(animekey);
            const anim = this.scene?.anims?.get?.(animekey);
            if (anim && anim.frames && anim.frames.length > 0) {
                super.play(animekey);
            } else {
                this.anims?.stop?.();
            }
        }
    }
    static loadAssets(scene, key, framex, framey, keylink) {
        loadSpritesheet(scene, `${key}`, `${keylink}`, framex, framey)
    }
    static loadAnime(scene, key, framex, load) {
        if (load) {
            const frames = scene.anims.generateFrameNumbers(`${key}`);
            if (frames && frames.length > 0) {
                scene.anims.create({
                    key: `${key}`,
                    frames: frames,
                    frameRate: framex,
                    repeat: -1,
                });
            }
        }
    }
}
export class GalaxyBar extends Entity {
    constructor(scene, x, y) {
        super(scene, x, y, "Galaxy bar");
        this.setDepth(3);
    }
}
export class Button extends Entity {
    constructor(scene, x, y, key) {
        super(scene, x, y, key);
        this.scaleX = 0.7;
        this.scaleY = 0.7;
    }
}